// Runtime configuration from Vite env variables (see .env.example).
// Only PUBLIC values belong here. A service-role / secret key is refused outright.

const env = import.meta.env ?? {};

export const config = Object.freeze({
  supabaseUrl: (env.VITE_SUPABASE_URL ?? '').trim(),
  supabaseAnonKey: (env.VITE_SUPABASE_ANON_KEY ?? '').trim(),
  appEnv: env.VITE_APP_ENV ?? 'development',
  appBaseUrl: (env.VITE_APP_BASE_URL ?? (typeof window !== 'undefined' ? window.location.origin : '')).replace(/\/$/, ''),
  defaultTimezone: env.VITE_DEFAULT_TIMEZONE ?? 'Asia/Karachi',
  functionsUrl: (env.VITE_SUPABASE_URL ?? '').trim().replace(/\/$/, '') + '/functions/v1',
});

function decodeJwtPayload(token) {
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

/**
 * Returns a list of human-readable configuration problems (empty when valid).
 * Exported separately so it can be unit-tested with arbitrary input.
 */
export function configProblems(cfg = config) {
  const problems = [];
  if (!cfg.supabaseUrl) {
    problems.push('VITE_SUPABASE_URL is not set.');
  } else {
    let url;
    try { url = new URL(cfg.supabaseUrl); } catch { problems.push('VITE_SUPABASE_URL is not a valid URL.'); }
    if (url) {
      const local = ['localhost', '127.0.0.1'].includes(url.hostname);
      if (url.protocol !== 'https:' && !local) problems.push('VITE_SUPABASE_URL must use https.');
    }
  }
  const key = cfg.supabaseAnonKey;
  if (!key) {
    problems.push('VITE_SUPABASE_ANON_KEY is not set (use the public anon / publishable key).');
  } else if (key.startsWith('sb_secret_') || decodeJwtPayload(key)?.role === 'service_role') {
    problems.push('A service-role / secret key was supplied. Remove it immediately and rotate it in Supabase — only the public anon/publishable key may be used in the browser.');
  }
  return problems;
}

export const isConfigured = () => configProblems().length === 0;
